
import { Mandat } from "@/models/payment/mandat";
import { AuthService } from "@/services/auth-service";
import { PaymentService } from "@/services/payment-service";
import Vue from "vue";
import AppPaymentMethodCard from "./PaymentMethodCard.vue";

export default Vue.extend({
	props: {
		mandat: {
			type: Object as ()=>Mandat
		}
	},
	computed: {
		isDemo():boolean {
			return AuthService.wfCompany.IsDemo;
		}
	},
	methods: {
		async activateMandate() {
			let confirm = await this.$wf.confirm(this.$ct("cofirm-change-payment"), this.$t("common.yes"), this.$t("common.no"), this.$ct("common.warning"), "info");
			if (!confirm) return;
			await PaymentService.setMandateAsActive(this.mandat.id);
			this.$emit("refresh");
		},
		async deleteMandate() {
			if (this.mandat.isActive) {
				this.$wf.dialog(this.$ct("errors.cannot-delete-mandate"), this.$ct("common.ok").toString(), this.$ct("common.attention"));
				return;
			}
			let confirm = await this.$wf.confirm(this.$ct("cofirm-delete-payment"), this.$t("common.yes"), this.$t("common.no"), this.$ct("common.warning"), "warning");
			if (!confirm) return;
			await PaymentService.deleteMandate(this.mandat.id);
			this.$emit("refresh");
		},
		cardLabel(m: Mandat): String {
			return m.details.cardLabel ? m.details.cardLabel + " •••• " : m.details.consumerAccount;
		},
	},
	components: {
		AppPaymentMethodCard
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
